var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.317,
    height: 16.317,
    viewBox: "0 0 16.317 16.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "question-circle",
    d: "M16.158,18.922a.921.921,0,1,0,.921.921A.921.921,0,0,0,16.158,18.922Zm.252-.79h-.526a.4.4,0,0,1-.395-.395v-.013c0-2.314,2.548-2.093,2.548-3.533,0-.658-.584-1.323-1.89-1.323a2.174,2.174,0,0,0-1.948.944.394.394,0,0,1-.535.078l-.432-.3a.394.394,0,0,1-.087-.565,3.452,3.452,0,0,1,3-1.472c1.721,0,3.205.979,3.205,2.639,0,2.218-2.548,2.1-2.548,3.533v.013A.4.4,0,0,1,16.411,18.132Zm-.252-9.08a7.218,7.218,0,0,1,6.657,4.614,6.675,6.675,0,0,1,.448,2.491,7.106,7.106,0,1,1-7.106-7.106m0-1.053a8.158,8.158,0,1,0,8.158,8.158A8.16,8.16,0,0,0,16.158,8Z",
    transform: "translate(-8 -8)",
    fill: "#8ba5bc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.61c12fdc257ed49ea513de7be6a10e51.svg";
export { ForwardRef as ReactComponent };